import { Typography } from "@mui/material"
import ConfirmDialog from "@components/ConfirmDialog"

type UnitToggleOffWarningDialogProps = {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

const UnitToggleOffWarningDialog = ({
  open,
  onConfirm,
  onCancel,
}: UnitToggleOffWarningDialogProps) => {
  return (
    <ConfirmDialog
      open={open}
      dialogTitle={"Confirm toggling off a unit format"}
      onClose={(value) => (value ? onConfirm() : onCancel())}
    >
      <Typography variant={"h6"}>
        Are you sure to toggle off unit format? Doing so will remove all unit formatting from your
        node and may cause your graph to display incorrectly.
      </Typography>
    </ConfirmDialog>
  )
}

export default UnitToggleOffWarningDialog
